export const OPENLUX_DEFAULTS_V1014 = Object.freeze({
  'gemini-3.1-flash-image': 'gemini_image',
  'gemini-3-pro-image': 'gemini_image',
});

export function selectCompatibleProfileV1014(config, profile, vertex) {
  const next = { ...config, openai_compatible_profile: profile };
  if (profile === 'openlux') {
    delete next.vertex_ai_service_tier;
    delete next.protocol_capabilities_v5;
    delete next.outbound_client_profile_v95;
    delete next.api_version;
  } else if (vertex || profile === 'voycloud') {
    const allowed =
      profile === 'voycloud'
        ? ['standard', 'flex', 'batch']
        : ['standard', 'flex'];
    next.vertex_ai_service_tier = allowed.includes(next.vertex_ai_service_tier)
      ? next.vertex_ai_service_tier
      : 'standard';
  } else if (config.openai_compatible_profile === 'voycloud') {
    delete next.vertex_ai_service_tier;
  }
  return next;
}

export function openLuxRulesV1014(config) {
  return {
    ...OPENLUX_DEFAULTS_V1014,
    ...config.openlux_model_strategies_v1014,
  };
}

export function validOpenLuxModelV1014(name) {
  return Boolean(
    name &&
      name !== '.' &&
      name !== '..' &&
      name.length <= 200 &&
      name.trim() === name &&
      !/[\/\\?#%:*\s]/.test(name)
  );
}

export function buildOpenLuxSubmissionV1015(config, draft) {
  if (config.openai_compatible_profile !== 'openlux' || !draft?.model?.trim()) {
    return config;
  }
  const model = draft.model.trim();
  const custom = config.openlux_model_strategies_v1014 || {};
  if (
    !validOpenLuxModelV1014(model) ||
    Object.hasOwn(openLuxRulesV1014(config), model) ||
    Object.keys(custom).length >= 256 ||
    !['gemini_image', 'passthrough'].includes(draft.strategy)
  ) {
    throw new Error('channel.edit.openlux_v1014.invalid');
  }
  return {
    ...config,
    openlux_model_strategies_v1014: { ...custom, [model]: draft.strategy },
  };
}
